import { useUserAgentDevice } from '@packages/shared';
import type { Device } from '@packages/themes/src/default';

export const getChannelFromDevice = (device: Device) => {
  if (device === 'mobile') return 'mob';
  if (device === 'tablet') return 'tab';

  return 'web';
};

/**
 * Get the user personalization channel, based on the user agent.
 */
export const useChannel = () => {
  const userAgentDevice = useUserAgentDevice();

  return getChannelFromDevice(userAgentDevice);
};
